import { createHashHistory } from 'history'
import { createEnhancer } from './middleware'
import configureReducer from '../reducer'
import createStore from './store'

const configureStore = () => {
  const history = createHashHistory()
  const reducer = configureReducer(history)
  const enhancer = createEnhancer(history)
  const { persistor, store } = createStore(reducer, enhancer)
  return { persistor, store, history }
}

export const { store, persistor, history } = configureStore()
window.store = store
